export default "__VITE_ASSET__f6bd91c7__"